export default __webpack_public_path__ + "static/media/step2-b.ee66c342.png";